import { Configuration } from "./models/config";
import { STRAPI_SERVER_URL } from "@app/config";

export function getConfig(): Configuration {
  return {
    api: {
      baseUrl: STRAPI_SERVER_URL as string,
    },
  };
}
